import { Typography } from '@analytical-alley/ui';
import React, { useState } from 'react';
import { HiChevronDown, HiChevronRight } from 'react-icons/hi';

interface Props {
    channels: string[];
    variableNameMap: Record<string, string>;
}

export function FilteredChannels({ channels, variableNameMap }: Props) {
    const [expanded, setExpanded] = useState(false);

    if (channels.length === 0) return null;

    return (
        <div className="mx-3 mb-2 rounded-lg border border-white/5 bg-white/2">
            <button
                type="button"
                onClick={() => setExpanded((v) => !v)}
                className="flex w-full items-center gap-2 px-4 py-2.5 text-left cursor-pointer hover:bg-white/3 rounded-lg transition-colors"
            >
                {expanded ? (
                    <HiChevronDown className="h-4 w-4 text-white/40 shrink-0" />
                ) : (
                    <HiChevronRight className="h-4 w-4 text-white/40 shrink-0" />
                )}
                <Typography variant="bodyXS" className="text-white/50">
                    {channels.length} filtered{' '}
                    {channels.length === 1 ? 'channel' : 'channels'}
                </Typography>
            </button>
            {expanded && (
                <div className="flex flex-wrap gap-1.5 px-4 pb-3">
                    {channels.map((channel) => (
                        <span
                            key={channel}
                            className="inline-flex items-center rounded-md bg-white/5 px-2 py-0.5 text-[11px] text-white/40"
                        >
                            {variableNameMap[channel] || channel}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
}
